import * as moment from "moment";

export const getFormatedDate = (startDate: any, endDate: any) => {
  startDate = moment(startDate).format("YYYY-MM-DD") + " 00:00:00";
  endDate = moment(endDate).format("YYYY-MM-DD") + " 23:59:59";
  return { startDate, endDate };
};

export const formatData = (arr: [{}]) => {
  return arr.map((obj) => {
    for (const [key, value] of Object.entries(obj)) {
      if (value === null) {
        obj[key] = "N/A";
      } else if (value === 0) {
        obj[key] = "0";
      } else if (moment(value, moment.ISO_8601, true).isValid()) {
        obj[key] = moment(value).format("MMMM D YYYY, hh:mm A");
      }
    }
    return obj;
  });
};
